import React from "react";
import packageJson from "../../../package.json";

const Copyright = React.memo(() => {
  const year = new Date().getFullYear();
  return (
    <div className="text-right font-light text-12 bg-pl-bg text-pl-text-secondary">
      <div>
        Copyright &copy;{" "}
        <a
          href="https://www.paralegal.lk"
          target="_blank"
          rel="noopener noreferrer"
          className="text-pl-accent font-medium hover:underline"
        >
          paralegal.lk
        </a>{" "}
        <span id="year">{year}</span> | All Rights Reserved.{" "}
        <div className="inline-block">Version: {packageJson.version}</div>
      </div>
    </div>
  );
});

export default Copyright;
